import devices_url from "@/assets/images/why-trackmate/devices.jpg";
import features_url from "@/assets/images/why-trackmate/features.jpg";
import { ROUTES } from "@/utils/navigation";

export const options = [
  {
    imgUrl: features_url,
    title: "Trackmate features",
    description: "We are setting new standards in the industry with more accurate, reliable and efficient features than ever before.",
    href: ROUTES.features,
    label: "See Trackmate features"
  },
  {
    imgUrl: devices_url,
    title: "Trackmate devices",
    description: "Our vehicle and asset GPS tracking devices are simple to use and integrate seamlessly with our intuitive management platform.",
    href: ROUTES.solutions,
    label: "Trackmate devices"
  }
]